import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { industries } from "../Data";


// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Swiper styles
import "swiper/css";

const IndustriesSlider = () => {
  return (
    <section className="industries-section">

      {/* HEADER */}
      <div className="industries-header">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          Logistics Solutions for Diverse Industries
        </motion.h2>

        <motion.button
          className="primary-btn"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.95 }}
          viewport={{ once: true }}
        >
          <Link to="/industries">Explore Industries</Link>
        </motion.button>
      </div>

      {/* SLIDER */}
      <div className="slider-wrapper">
        <Swiper
          modules={[Autoplay]}
          slidesPerView={4}
          spaceBetween={0}
          loop
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          speed={600}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
        >
          {industries.map((item, i) => (
            <SwiperSlide key={i}>
              <motion.div
                className="industry-card"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  delay: i * 0.1,
                  duration: 0.6,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
                whileHover={{ y: -10, scale: 1.05 }}
              >
                <Link
                  to={`/industries/${item.slug}`}
                  className="service-card-link"
                >
                  <motion.div
                   className="industry-icon" 
                    initial={{ scale: 0, rotate: -90 }}
                    whileInView={{ scale: 1, rotate: 0 }}
                    transition={{
                      type: "spring",
                      stiffness: 250,
                      delay: i * 0.1,
                    }}
                    viewport={{ once: true }}
                  >
                   {item.icon}
                  </motion.div>

                  <h3>{item.title.replace(/,/g, ", ")}</h3>
                </Link>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

    </section>
  );
};

export default IndustriesSlider;
